// OCTAGON INFINITY TERMS OF SERVICE CONTENT
// Edit this file to update the terms of service content

export const termsOfServiceContent = {
  title: "Terms of Service",
  subtitle: "Octagon Infinity",
  effectiveDate: "Effective Date: November 14, 2025",
  lastUpdated: "Last Updated: November 14, 2025",
  
  sections: [
    {
      id: "acceptance",
      title: "1. Acceptance of Terms",
      content: `These Terms of Service ("Terms") constitute a legally binding agreement between you and Octagon Infinity ("Company," "we," "us," or "our") governing your access to and use of the octagon8.io website and our NFT-based real estate investment platform (collectively, the "Services").

By accessing or using our Services, you acknowledge that you have read, understood, and agree to be bound by these Terms, including our Privacy Policy and Risk Disclosure. If you do not agree to these Terms, you must not access or use our Services.

We reserve the right to modify these Terms at any time. Continued use of our Services following any changes constitutes acceptance of the modified Terms.`
    },
    
    {
      id: "eligibility",
      title: "2. Eligibility and Account Requirements",
      content: `2.1 Age and Legal Capacity:
• You must be at least 18 years of age or the age of legal majority in your jurisdiction
• You must have the legal capacity to enter into binding contracts
• You must not be located in a jurisdiction where our Services are prohibited

2.2 Geographic Restrictions:
Our Services may not be available in all jurisdictions. You agree not to access or use our Services if you are located in:
• Any country subject to international sanctions
• Jurisdictions where cryptocurrency or NFT transactions are prohibited
• Regions where real estate tokenization is not permitted

2.3 Account Registration:
• You must provide accurate, current, and complete information during registration
• You are responsible for maintaining the confidentiality of your account credentials
• You must notify us immediately of any unauthorized access to your account
• You may not transfer or share your account with others

2.4 KYC/AML Compliance:
• You must complete identity verification (KYC) procedures
• You must provide accurate documentation for Anti-Money Laundering (AML) compliance
• We reserve the right to refuse service to anyone who fails verification`
    },
    
    {
      id: "services-description",
      title: "3. Description of Services",
      content: `3.1 VIP Pass NFTs:
Octagon Infinity offers 10,000 VIP Pass NFTs at 0.24 ETH each. Each NFT represents:
• Investment rights in curated European real estate projects
• €4,000 base investment power
• Rarity-based multipliers (1.0x to 2.0x)
• Participation in platform governance
• Access to exclusive investment opportunities

3.2 Investment Structure:
• Tier 0: 2% monthly returns (24% annually)
• Tier 1: 4% monthly returns (48% annually)
• Tier 2: 6% monthly returns (72% annually)
• Tier 3: 8% monthly returns (96% annually)

3.3 Rarity Tiers:
• Green Card (60%): 1.0x multiplier
• Bronze Card (30%): 1.2x multiplier
• Silver Card (8%): 1.5x multiplier
• Gold Card (2%): 2.0x multiplier

3.4 Profit Distribution:
Monthly distributions are calculated as: Base Investment Power × Rarity Multiplier × Tier Return Rate

The actual distribution is subject to project performance and may vary from projected returns.`
    },
    
    {
      id: "nft-purchase",
      title: "4. NFT Purchase and Ownership",
      content: `4.1 Purchase Process:
• VIP Pass NFTs can be purchased through our platform for 0.24 ETH
• All purchases are final and non-refundable
• NFTs are minted on the blockchain upon successful payment
• You will receive confirmation of ownership via blockchain transaction

4.2 Ownership Rights:
By purchasing a VIP Pass NFT, you receive:
• Ownership of the digital asset (NFT) as recorded on the blockchain
• Investment rights corresponding to the NFT's tier and rarity
• Voting rights in platform governance decisions
• Access to platform features and services

4.3 What You Do NOT Own:
• The underlying intellectual property of the NFT artwork
• Direct ownership of physical real estate properties
• Guaranteed returns or profits from investments
• Rights beyond those explicitly granted in these Terms

4.4 Transfer and Resale:
• You may transfer or sell your NFT on supported secondary markets
• All transfers must comply with applicable securities laws
• We do not facilitate or guarantee secondary market transactions
• Transfer of NFT transfers all associated investment rights`
    },
    
    {
      id: "investment-terms",
      title: "5. Investment Terms and Conditions",
      content: `5.1 Nature of Investment:
• Investments through VIP Pass NFTs are high-risk and speculative
• Past performance does not guarantee future results
• Projected returns are estimates and not guarantees
• Real estate markets are subject to volatility and economic conditions

5.2 Capital Deployment:
• Funds collected through NFT sales will be invested in European real estate projects
• Project selection is at the sole discretion of Octagon Infinity management
• Investment timeline and allocation may vary based on market conditions
• We will provide regular updates on project status and performance

5.3 Profit Distribution:
• Distributions are made monthly based on project performance
• Minimum distribution threshold may apply
• Distributions are made in cryptocurrency or as otherwise specified
• We reserve the right to reinvest profits for platform growth

5.4 No Guaranteed Returns:
YOU ACKNOWLEDGE AND AGREE THAT:
• All projected returns are estimates only
• Actual returns may be higher, lower, or negative
• You may lose your entire investment
• We make no warranties or guarantees regarding investment performance`
    },
    
    {
      id: "user-obligations",
      title: "6. User Obligations and Prohibited Conduct",
      content: `6.1 Compliance:
You agree to comply with all applicable laws and regulations, including:
• Securities laws and regulations
• Tax reporting and payment obligations
• Anti-money laundering (AML) regulations
• Know Your Customer (KYC) requirements

6.2 Prohibited Activities:
You may not:
• Violate any laws or regulations
• Engage in fraudulent, manipulative, or deceptive practices
• Use the Services for money laundering or terrorist financing
• Attempt to circumvent security measures or access controls
• Impersonate others or provide false information
• Interfere with the operation of the Services
• Use automated systems or bots without authorization
• Reverse engineer or attempt to extract source code

6.3 Wallet Security:
You are solely responsible for:
• Securing your cryptocurrency wallet and private keys
• All transactions initiated from your wallet
• Protecting your account credentials
• Backing up your wallet information`
    },
    
    {
      id: "intellectual-property",
      title: "7. Intellectual Property Rights",
      content: `7.1 Company Property:
All content, features, and functionality of our Services, including but not limited to:
• Website design, layout, and graphics
• Software, code, and technology
• Trademarks, logos, and branding
• Text, images, and multimedia content

remain the exclusive property of Octagon Infinity and are protected by copyright, trademark, and other intellectual property laws.

7.2 Limited License:
We grant you a limited, non-exclusive, non-transferable, revocable license to access and use our Services for their intended purpose, subject to these Terms.

7.3 NFT Artwork:
Ownership of a VIP Pass NFT grants you a non-commercial, personal use license to the associated artwork. You may not:
• Use the artwork for commercial purposes without permission
• Modify, reproduce, or create derivative works
• Register trademarks or copyrights for the artwork
• Claim ownership of the underlying intellectual property

7.4 User Content:
By submitting content to our Services, you grant us a worldwide, royalty-free license to use, reproduce, and display such content for operating and promoting our Services.`
    },
    
    {
      id: "disclaimers",
      title: "8. Disclaimers and Warranties",
      content: `8.1 SERVICE PROVIDED "AS IS":
OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
• Warranties of merchantability or fitness for a particular purpose
• Warranties of non-infringement
• Warranties regarding accuracy, reliability, or completeness of information
• Warranties regarding uninterrupted or error-free service

8.2 Investment Disclaimer:
• We are not registered investment advisors or financial advisors
• Nothing on our platform constitutes investment advice
• You should consult with qualified professionals before making investment decisions
• All investment decisions are your sole responsibility

8.3 Blockchain Disclaimer:
• Blockchain transactions are irreversible
• We have no control over blockchain networks or their operation
• Network congestion, gas fees, and other factors may affect transactions
• Smart contract functionality depends on blockchain infrastructure

8.4 No Guarantee of Service:
• We do not guarantee continuous, uninterrupted, or secure access to our Services
• Services may be suspended or discontinued without notice
• Technical issues, maintenance, or security concerns may interrupt service`
    },
    
    {
      id: "limitation-liability",
      title: "9. Limitation of Liability",
      content: `TO THE MAXIMUM EXTENT PERMITTED BY LAW:

9.1 Exclusion of Damages:
IN NO EVENT SHALL OCTAGON INFINITY, ITS DIRECTORS, OFFICERS, EMPLOYEES, OR AFFILIATES BE LIABLE FOR:
• Any indirect, incidental, special, consequential, or punitive damages
• Loss of profits, revenue, data, or business opportunities
• Loss or theft of cryptocurrency or digital assets
• Damages resulting from unauthorized access to your account
• Damages arising from third-party actions or services

9.2 Cap on Liability:
OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATED TO THESE TERMS OR THE SERVICES SHALL NOT EXCEED THE LESSER OF:
• The amount you paid to us in the 12 months preceding the claim, or
• €1,000

9.3 Essential Purpose:
The limitations and exclusions in this section apply even if any remedy fails of its essential purpose.

9.4 Jurisdictional Limitations:
Some jurisdictions do not allow the exclusion or limitation of certain damages. In such jurisdictions, our liability will be limited to the maximum extent permitted by law.`
    },
    
    {
      id: "indemnification",
      title: "10. Indemnification",
      content: `You agree to indemnify, defend, and hold harmless Octagon Infinity, its affiliates, officers, directors, employees, agents, and licensors from and against any claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from or related to:

• Your violation of these Terms
• Your violation of any laws or regulations
• Your violation of any third-party rights
• Your use or misuse of our Services
• Any false or misleading information you provide
• Your investment activities or decisions
• Tax obligations or penalties related to your investments
• Any dispute between you and other users

This indemnification obligation survives termination of these Terms and your use of our Services.`
    },
    
    {
      id: "dispute-resolution",
      title: "11. Dispute Resolution and Arbitration",
      content: `11.1 Informal Resolution:
Before initiating any formal dispute resolution, you agree to contact us at legal@octagon8.io to attempt to resolve the dispute informally for at least 30 days.

11.2 Binding Arbitration:
Any dispute, controversy, or claim arising out of or relating to these Terms or our Services that cannot be resolved informally shall be resolved by binding arbitration administered by [Arbitration Institution] in accordance with its rules.

11.3 Arbitration Terms:
• Arbitration will be conducted by a single arbitrator
• The arbitration shall take place in [Jurisdiction]
• The language of arbitration shall be English
• Each party shall bear their own costs and fees
• The arbitrator's decision shall be final and binding

11.4 Class Action Waiver:
YOU AGREE TO RESOLVE DISPUTES WITH US ON AN INDIVIDUAL BASIS. YOU WAIVE ANY RIGHT TO PARTICIPATE IN CLASS ACTIONS, CLASS ARBITRATIONS, OR REPRESENTATIVE PROCEEDINGS.

11.5 Exceptions:
Either party may seek injunctive or other equitable relief in court to protect intellectual property rights or prevent unauthorized use of the Services.`
    },
    
    {
      id: "termination",
      title: "12. Termination and Suspension",
      content: `12.1 Termination by You:
You may terminate your account at any time by contacting support@octagon8.io. Termination does not:
• Entitle you to refunds of NFT purchases
• Terminate your ownership of purchased NFTs
• Affect your investment obligations or rights

12.2 Termination by Us:
We may suspend or terminate your access to our Services at any time, with or without notice, for:
• Violation of these Terms
• Fraudulent or illegal activity
• Failure to complete KYC/AML verification
• Suspicious or unauthorized account activity
• Any reason at our sole discretion

12.3 Effect of Termination:
Upon termination:
• Your right to access the Services immediately ceases
• We may delete your account and data (subject to legal requirements)
• Outstanding obligations and liabilities remain in effect
• Provisions that by their nature should survive termination will survive`
    },
    
    {
      id: "governing-law",
      title: "13. Governing Law and Jurisdiction",
      content: `13.1 Governing Law:
These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction], without regard to its conflict of law provisions.

13.2 Jurisdiction:
Subject to the arbitration provisions, you agree to submit to the exclusive jurisdiction of the courts located in [Jurisdiction] for resolution of any disputes.

13.3 Regulatory Compliance:
Our operations comply with applicable securities laws, financial regulations, and consumer protection laws in the jurisdictions where we operate.`
    },
    
    {
      id: "miscellaneous",
      title: "14. Miscellaneous Provisions",
      content: `14.1 Entire Agreement:
These Terms, together with our Privacy Policy and Risk Disclosure, constitute the entire agreement between you and Octagon Infinity regarding the Services.

14.2 Severability:
If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.

14.3 Waiver:
Our failure to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.

14.4 Assignment:
You may not assign or transfer these Terms without our prior written consent. We may assign our rights and obligations without restriction.

14.5 Force Majeure:
We shall not be liable for any failure or delay in performance due to circumstances beyond our reasonable control, including acts of God, war, terrorism, natural disasters, or government actions.

14.6 No Partnership:
Nothing in these Terms creates a partnership, joint venture, agency, or employment relationship between you and Octagon Infinity.

14.7 Third-Party Beneficiaries:
These Terms do not confer any rights or benefits to third parties.`
    },
    
    {
      id: "contact-information",
      title: "15. Contact Information",
      content: `For questions, concerns, or notices regarding these Terms of Service, please contact us:

General Inquiries: info@octagon8.io
Legal Department: legal@octagon8.io
Support: support@octagon8.io

Mailing Address:
Octagon Infinity
[Company Address]
[City, Country, Postal Code]

For legal notices, please send correspondence to our registered office address or email legal@octagon8.io.`
    }
  ]
};
